<template>
  <!-- 사업자 기본 정보 -->
  <div class="column is-7">
    <div class="box">
      <admin-box-item title="사업자/계좌 정보" subtitle="파트너 관리를 위해 사업자정보 및 정산 관련 정보들을 입력하는 패널으로, 서비스 프론트에 노출되지 않습니다.">
        <div class="columns is-multiline">
          <div class="column is-full">
            <admin-form-item label="사업자 등록번호">
              <input class="input"
                     style="width:250px"
                     :value="business.biz_number"
                     @input="e=> business.biz_number = e.target.value"
                     placeholder="-없이 입력"
                     type="text">
            </admin-form-item>
          </div>

          <div class="column is-6">
            <admin-form-item label="상호명(법인명)">
              <input class="input"
                     style="width:250px"
                     :value="business.name"
                     @input="e=> business.name = e.target.value"
                     type="text">
            </admin-form-item>
          </div>

          <div class="column is-6">
            <admin-form-item label="연락처">
              <input class="input"
                     style="width:250px"
                     :value="business.phone"
                     @input="e=> business.phone = e.target.value"
                     type="text" maxlength="13">
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="사업자 종류">
              <lp-radio :val.sync="business.biz_type"
                        value_name="value"
                        label_name="label"
                        :data="bizTypeArr"></lp-radio>
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="세금계산서">
              <lp-check-bool :checkedVal.sync="business.is_tax_check" label="발행"
                             style="margin-right:20px;"></lp-check-bool>
              <input class="input"
                     style="width:250px"
                     :value="business.tax_email"
                     @input="e=> business.tax_email = e.target.value"
                     placeholder="이메일 주소 입력"
                     type="text"
                     v-if="business.is_tax_check">
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="정산계좌">
              <div class="columns is-multiline">
                <div class="column is-3">
                  <span class="select">
                    <select v-model="business.bank_info.bank" @change="e=> business.bank_info.bank = e.target.value">
                      <option value="" disabled selected>은행 선택</option>
                      <option v-for="(bank, idx) in bankArr" :key="`bank-${idx}`">{{ bank.label }}</option>
                    </select>
                  </span>
                </div>

                <div class="column is-6">
                  <input class="input"
                         :value="business.bank_info.account_num"
                         @input="e=> business.bank_info.account_num = e.target.value"
                         placeholder="계좌번호"
                         type="text">
                </div>

                <div class="column is-3">
                  <input class="input"
                         :value="business.bank_info.name"
                         @input="e=> business.bank_info.name = e.target.value"
                         placeholder="계좌주"
                         type="text">
                </div>
              </div>
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="사업자 등록증 첨부">
              <input-img :url.sync="business.img_registration" :idx="1"></input-img>
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="통장 사본">
              <input-img :url.sync="business.img_bank_book" :idx="2"></input-img>
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="가입비">
              <input class="input"
                     style="width:250px"
                     :value="business.sign_price"
                     @input="e=> business.sign_price = e.target.value"
                     type="number">
            </admin-form-item>
          </div>

          <div class="column is-full" v-if="isAdmin">
            <admin-form-item label="수수료">
              <lp-radio :val.sync="business.is_comm"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
            </admin-form-item>

            <admin-form-item label="수수료 방법" v-if="business.is_comm">
              <lp-radio :val.sync="business.comm_type"
                        value_name="value"
                        label_name="label"
                        :showInput="true"
                        :block="true"
                        @onEdit="res => onEdit(res, 'comm')"
                        :data="[{label:'수수료율', value:0, num: business.comm_rate, unit:'%'},
                                    {label:'수수료금액', value:1, num: business.comm_price, unit:'원'}]"></lp-radio>
            </admin-form-item>

            <admin-form-item label="수수료 적용 기간" v-if="business.is_comm">
              <div class="flex" style="flex-wrap:wrap">
                <div style="align-items: center;">
                  <admin-date-picker
                    type="datetime"
                    :data="business.comm_start"
                    @setDate="date => selDateMin(date, 'comm')"></admin-date-picker>
                </div>
                <div class="lp-dating">&#126;</div>
                <div style="align-items: center;">
                  <admin-date-picker
                    type="datetime"
                    :data="business.comm_end"
                    @setDate="date => selDateMax(date, 'comm')"></admin-date-picker>
                </div>
              </div>
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="가입기간">
              <div class="flex" style="flex-wrap:wrap">
                <div style="align-items: center;">
                  <admin-date-picker
                    type="datetime"
                    :data="business.joined_time"
                    @setDate="date => selDateMin(date, 'join')"></admin-date-picker>
                </div>
                <div class="lp-dating">&#126;</div>
                <div style="align-items: center;">
                  <admin-date-picker
                    type="datetime"
                    :data="business.expired_time"
                    @setDate="date => selDateMax(date, 'join')"></admin-date-picker>
                </div>
              </div>
            </admin-form-item>
          </div>


        </div>
      </admin-box-item>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../common/LpRadio";
  import LpCheckBool from "../common/LpCheckBool";
  import InputImg from "../common/InputImg";

  export default {
    props: {

      // 사업자 정보
      business: {
        type: Object,
        required: true
      }

    },
    components: {
      InputImg,
      LpCheckBool,
      LpRadio

    },
    data() {
      return {
        bizTypeArr: [
          {label: '일반과세', value: '일반과세'},
          {label: '간이과세', value: '간이과세'},
          {label: '법인', value: '법인'},
        ],
        bankArr: [
          {label: '신한은행', value: '신한은행'},
          {label: '우리은행', value: '우리은행'},
          {label: '국민은행', value: '국민은행'},
          {label: '하나은행', value: '하나은행'},
          {label: '기업은행', value: '기업은행'},
          {label: '농협', value: '농협'}
        ],
      }
    },
    created() {
      this.getBankList();
    },
    watch: {
      'business.biz_number'(n) {
        this.business.biz_number = autoHyphenBiz(this.business.biz_number)
      },
      'business.phone'(n) {
        this.business.phone = autoHyphenPhone(this.business.phone)
      }
    },
    methods: {
      getBankList() {
        this.$axios.get('public/banks').then(res=>{
          this.bankArr = res.data;
        })
      },
      onEdit(res, type) {
        if ( type === 'comm'){
          if (res.value === 0) {
            this.business.comm_rate= parseInt(res.text);
          }
          else {
            this.business.comm_price= parseInt(res.text);
          }
        }
      },
      selDateMin(date, type){
        if(type==='join') this.business.joined_time=date;
        else if(type==='comm') this.business.comm_start=date;
      },
      selDateMax(date, type){
        if(type==='join') this.business.expired_time=date;
        else if(type==='comm') this.business.comm_end=date;
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
